import { Component } from '@verndale/core';
import { BREAKPOINTS } from '../constants';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $tabs: this.el._$('.quick-access-card__tabs'),
      $panels: this.el._$$('.quick-access-card__panel'),
      $triggers: this.el._$$('.quick-access-card__trigger'),
      $triggersContainer: this.el._$('.quick-access-card__triggers'),
      $triggerItems: this.el._$$('.quick-access-card__trigger-item'),
      $inPanelTriggers: this.el._$$('.quick-access-card__in-panel-trigger'),
      $cardTitles: this.el._$$('.quick-access-card__card-title')
    };

    this.identifier = this.dom.$tabs.dataset.identifier;
    this.tabsDisplayBreakpoint = window.matchMedia(`(min-width: ${BREAKPOINTS.TABLET_LANDSCAPE}px)`);
    this.setup();
    this.activateFirstTab();
  }

  addListeners() {
    this.dom.$inPanelTriggers._on('click', this.handleInPanelTriggerClick.bind(this));
    this.tabsDisplayBreakpoint.addEventListener('change', this.activateFirstTab.bind(this));
  }

  setup() {
    this.dom.$triggerItems.forEach((el, i) => {
      this.dom.$triggersContainer.append(el);
      const $trigger = el._$('.quick-access-card__trigger');
      $trigger.setAttribute('role', 'tab');
      $trigger.dataset.index = i;
      $trigger.dataset.identifier = this.identifier;
      this.dom.$panels[i].dataset.identifier = this.identifier;
      this.dom.$cardTitles[i].innerHTML = `<h3>${el.textContent.trim()}</h3>`;
    });
  }

  handleInPanelTriggerClick(e) {
    const $el = e.target;
    const $panel = $el.closest('.quick-access-card__panel');
    const id = $el.dataset.id;
    const isHidden = $panel.getAttribute('aria-hidden') === 'true';
    const eventName = isHidden ? 'activatetab' : 'deactivatetab';
    const event = new CustomEvent(eventName, { detail: { id, keepOtherTabsActivated: true } });

    this.dom.$tabs.dispatchEvent(event);
  }

  activateFirstTab() {
    if (!this.tabsDisplayBreakpoint.matches) return;
    if (this.dom.$triggers.find(el => el.getAttribute('aria-selected') === 'true')) return;

    const tab = this.dom.$triggers[0];
    tab.setAttribute('aria-selected', 'true');
    const controls = tab.getAttribute('aria-controls');
    document.getElementById(controls).removeAttribute('aria-hidden');
  }
}

export default Module;
